import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { BackofficeUpdateRecipeListResponse } from '@diamond/shared/types';
import { useState } from 'react';

import { RecepiesMaterialAndProductCard } from './recipe-material-and-product-card';

type Recipeable = Omit<
  BackofficeUpdateRecipeListResponse,
  'cg_3_business_types'
>;

type RecipeProductTabs<TData extends Recipeable> = {
  data: TData;
  isAuthenticated?: boolean;
  hasRecommendedProducts: boolean;
  hasAlternativeProducts: boolean;
  onClickRecommended?: () => void;
  onClickAlternative?: () => void;
};

export function RecipeProductTabs<TData extends Recipeable>({
  data,
  isAuthenticated,
  hasRecommendedProducts,
  hasAlternativeProducts,
  onClickRecommended,
  onClickAlternative,
}: RecipeProductTabs<TData>) {
  const [tabsIndex, setTabsIndex] = useState<number>(() => {
    if (!hasRecommendedProducts && hasAlternativeProducts) return 1;
    return 0;
  });

  return (
    <Tabs
      borderColor="gray.75"
      isFitted
      index={tabsIndex}
      onChange={(idx) => setTabsIndex(idx)}
    >
      {hasAlternativeProducts ? (
        <TabList borderColor="transparent">
          <Tab
            bg="white"
            px={1}
            borderColor="#D9D9D9"
            borderBottomWidth="4px"
            _selected={{
              borderColor: '#B80000',
            }}
            onClick={onClickRecommended}
          >
            Rekomendasi
          </Tab>

          <Tab
            bg="white"
            px={1}
            borderColor="#D9D9D9"
            borderBottomWidth="4px"
            _selected={{
              borderColor: '#B80000',
            }}
            onClick={onClickAlternative}
          >
            Alternatif
          </Tab>
        </TabList>
      ) : null}
      <TabPanels>
        <TabPanel pr="2">
          <RecepiesMaterialAndProductCard
            recipe={data}
            type="recommended_products"
            isAuthenticated={isAuthenticated}
          />
        </TabPanel>
        {hasAlternativeProducts ? (
          <TabPanel pr="2">
            <RecepiesMaterialAndProductCard
              recipe={data}
              type="alternative_products"
              isAuthenticated={isAuthenticated}
            />
          </TabPanel>
        ) : null}
      </TabPanels>
    </Tabs>
  );
}
